import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import frLocale from '@fullcalendar/core/locales/fr';
import timeGridPlugin from '@fullcalendar/timegrid';
import AgendaAffichageInfo from '../agenda_equipe/agendaAffichageInfo';






function AgendaAffichageArbitre(props) {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [evenement, setEvenement] = useState(null);
  const [affichage, setAffichage] = useState(false);
  const [info, setInfo] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/agenda/affichage/arbitre/${props.userData.user.donnée.results[0].id}`,
          {
            withCredentials: true
          }
        );
        setError(null);
        setIsLoading(false);
        const agendaMatch = response.data.match.map(item => ({
          title: item.equipe_dom + " vs " + item.equipe_ext,
          start: modificationDateMatch(item.date),
          end: modificationDateMatch(item.date, true),
          color: 'rgba(0, 230, 118, 1)',
          defId : item.id_match,
          className: 'color-1',
          
        }));
        
        const agenda = [...agendaMatch];
        setEvenement(agenda);
      } catch (error) {
        if (error.response) {
          setError(error.response.data.message);
        } else {
          console.log(error);
          setError(true);
        }
        setIsLoading(false);
      }
    };
    fetchData();
  }, [apiUrl, props.userData]);

  const modificationDateMatch = (dateString, adjustEndTime = false) => {
    const parts = dateString.split(' - ');
    const datePart = parts[0];
    const timePart = parts[1];
    const [, dayOfMonth, month] = datePart.split(' ');

    const months = {
      'janvier': 0, 'février': 1, 'mars': 2, 'avril': 3,
      'mai': 4, 'juin': 5, 'juillet': 6, 'août': 7,
      'septembre': 8, 'octobre': 9, 'novembre': 10, 'décembre': 11
    };

    const year = new Date().getFullYear();
    const monthIndex = months[month.toLowerCase()];

    const date = new Date(year, monthIndex, parseInt(dayOfMonth, 10));
    const [hour, minute] = timePart.split(':');

    date.setHours(parseInt(hour, 10));
    date.setMinutes(parseInt(minute, 10));

    if (adjustEndTime) {
      date.setHours(date.getHours() + 1);
      date.setMinutes(date.getMinutes() + 45);
    }

    return date;
  };






  const infoEvent = (item) => {
    const debut_date = moment(item.event.start).format('YYYY-MM-DD');
    const debut_heure = moment(item.event.start).format('HH:mm');
    const fin_date = moment(item.event.end).format('YYYY-MM-DD');
    const fin_heure = moment(item.event.end).format('HH:mm');
    const id = item.event.extendedProps.defId; 
    const event = [item.event, debut_date, debut_heure, fin_heure, fin_date,id]
      setInfo(event);
      setAffichage(true);

  };



  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }
  return (
    <>
      <div>
        {affichage && (
          <AgendaAffichageInfo
            show={affichage}
            quit={() => { setAffichage(false); setInfo(null); }}
            info={info}
          />
        )}

        {error && 
          <div id="alert-message" className="alert4" style={{ fontSize: "15px" }}>
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
          </div>
        }
        {evenement && (
          <>
              <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin]}
                headerToolbar={{
                  left : 'prev,next today',
                  center : 'title',
                  right : 'dayGridMonth,timeGridWeek,timeGridDay'
                }}
                initialView="dayGridMonth"
                events={evenement} 
                eventClick={infoEvent} 
                locales={[frLocale]}
                themeSystem="bootstrap"
                weekNumbers={true} 
                fixedWeekCount={3} 
                height="auto"
                dayMaxEventRows={3} 
                eventContent={(arg, createElement) => {
                  return (
                    <>
                      <div><strong>{arg.timeText}: {arg.event.title}</strong></div>
                    </>
                  );
                }}
              />

              </>
            )}
      </div>
    </>
  );
}

export default AgendaAffichageArbitre;
